import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from "@angular/core";
import { NzStringTemplateOutletDirective } from "ng-zorro-antd/core/outlet";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { uiToNz } from "../../core.utils";

@Directive({
  selector: "[uiStringTemplateOutlet]",
  exportAs: "uiStringTemplateOutlet",
})
export class UiStringTemplateOutletDirective<T = unknown> extends NzStringTemplateOutletDirective<T> implements OnChanges {
  @Input("uiStringTemplateOutletContext") public nzStringTemplateOutletContext: NzSafeAny | null = null;
  @Input("uiStringTemplateOutlet") public nzStringTemplateOutlet: NzSafeAny | TemplateRef<NzSafeAny> = null;

  constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef<NzSafeAny>) {
    super(viewContainer, templateRef);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(uiToNz(changes));
  }
}
